import i18n from "./lib/i18n";

const confirmDeleteInModal = () => {
  const modal = window.$("#modal-delete");
  if (!modal) {
    return;
  }

  modal.on("show.bs.modal", showModal);
  modal.on("hidden.bs.modal", hideModal);

  if (autoTriggerModal()) {
    const trigger = document.querySelector("[data-toggle='modal']");
    trigger?.click();
  }
};

window.addEventListener("turbo:load", confirmDeleteInModal);
window.addEventListener("inertia-hack:invalid-route", confirmDeleteInModal);

const autoTriggerModal = () => {
  let url = new URL(window.location.href);
  return Boolean(url.searchParams.get("toggleDeleteModal"));
};

const showModal = (e) => {
  const skipVerification = Boolean(
    e.target.dataset.skipVerification === "true"
  );
  const currentResourceName = e.relatedTarget.dataset.resourceName;
  const maintenancePlansInformation =
    e.relatedTarget.dataset.maintenancePlansInformation;
  let confirmValue;
  if (skipVerification) {
    confirmValue = null;
  } else if (e.relatedTarget.dataset.type == "mass_edit") {
    confirmValue = e.relatedTarget.dataset.confirmValue;
  } else {
    confirmValue = e.relatedTarget.dataset.resourceName;
  }

  // manipulate form action
  const form = e.target.querySelector("form");
  form.action = e.relatedTarget.dataset.url;

  // listen to the verify input to enable the submit button if the value
  // matches the resource name, unless skipVerification is set to true
  if (!skipVerification) {
    const verifiedInput = form.querySelector("[data-verified]");
    verifiedInput.addEventListener("input", enableSubmitOnVerified);
  }

  // update information in modal
  updateNameOfResource(currentResourceName);
  updateConfirmValue(confirmValue);
  updateRelatedResourcesInformationForType(e.relatedTarget);
  updateMaintenancePlansInformation(maintenancePlansInformation);
};

const hideModal = (e) => {
  const submitButton = e.target.querySelector("[data-submit]");
  const skipVerification = Boolean(
    e.target.dataset.skipVerification === "true"
  );

  // The submit button needs to be disabled here since the event to toggle
  // the disabled state is not triggered when the modal is opened.
  submitButton.disabled = !skipVerification;
  if (skipVerification) {
    return;
  }

  // clear input value
  const verifiedInput = e.target.querySelector("[data-verified]");
  verifiedInput.value = "";

  verifiedInput.removeEventListener("input", enableSubmitOnVerified);
};

const enableSubmitOnVerified = () => {
  const submitButton = document.querySelector("#modal-delete [data-submit]");
  const verifiedInputValue = document
    .querySelector("#modal-delete [data-verified]")
    .value.toLowerCase();
  const confirmValue = document
    .querySelector("#modal-delete [data-confirm-value]")
    .innerText.toLowerCase();

  submitButton.disabled = verifiedInputValue != confirmValue;
};

const updateNameOfResource = (currentResourceName) => {
  document.querySelector("#modal-delete [data-name]").textContent =
    currentResourceName;
};

const updateConfirmValue = (confirmValue) => {
  if (!confirmValue) {
    return;
  }

  document.querySelector("#modal-delete [data-confirm-value]").textContent =
    confirmValue;
};

const updateRelatedResourcesInformationForType = (target) => {
  document.querySelector("#modal-delete [data-related-resources]").textContent =
    relatedResources(target);
};

const updateMaintenancePlansInformation = (maintenancePlansInformation) => {
  if (!maintenancePlansInformation) {
    return;
  }

  const maintenancePlans = document.querySelector(
    "#modal-delete [data-maintenance-plans]"
  );
  if (maintenancePlans) {
    maintenancePlans.textContent = maintenancePlansInformation;
  }
};

const relatedResources = (target) => {
  const type = target.dataset.type;
  const relatedResourceCount = target.dataset.relatedResourceCount;

  switch (type) {
    case "building":
      return i18n.t("js.confirm_delete_modal.case_building");
    case "facility":
      return i18n.t("js.confirm_delete_modal.case_facility");
    case "organization":
      return i18n.t("js.confirm_delete_modal.case_organization");
    case "app-customer":
      return i18n.t("js.confirm_delete_modal.case_app_customer");
    case "category":
      return i18n.t("js.confirm_delete_modal.case_category");
    case "mass_edit":
      return i18n.t("js.confirm_delete_modal.case_mass_edit");
    case "component":
      if (relatedResourceCount > 0) {
        return i18n.t("js.confirm_delete_modal.case_component_with_actions", {
          count: relatedResourceCount,
        });
      } else {
        return i18n.t("js.confirm_delete_modal.case_component_without_actions");
      }
    case "maintenance_plan_action":
    default:
      return i18n.t("js.confirm_delete_modal.default");
  }
};
